export default "__VITE_ASSET__RevR2Zff__"